import { FC } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import MuiCardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import { Column, Row } from 'further-ui/components/Layout';
import JourneyStepNumber from 'components/new/JourneyStepNumber';

const CardContent = styled(MuiCardContent)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.sm),
  '&:last-child': {
    paddingBottom: theme.spacing(theme.spacingSizes.sm),
  },
}));

type BasicCardProps = {
  title: string;
  description: string;
  outlined?: boolean;
  number?: number;
};

const BasicCardContent: FC<
  Pick<BasicCardProps, 'title' | 'description' | 'number'>
> = ({ title, description, number }) => (
  <Column spacing="xs" fullWidth>
    <Row centered spacing="xs">
      {number ? <JourneyStepNumber>{number}</JourneyStepNumber> : null}
      <Typography variant="h6">{title}</Typography>
    </Row>
    <Typography variant="body2">{description}</Typography>
  </Column>
);

const BasicCard: FC<BasicCardProps> = ({
  title,
  description,
  outlined = false,
  number,
}) => {
  const content = (
    <BasicCardContent title={title} description={description} number={number} />
  );

  return outlined ? (
    <Card variant="outlined">
      <CardContent>{content}</CardContent>
    </Card>
  ) : (
    content
  );
};

export default BasicCard;
